import bankApi from '../../../../api/bank';
import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';

const defaultState = () => ({
    dataBank: [],
    daftarBank: [],
    konfirmResponse: {},
    responSukses: ''
});

const state = defaultState();

const actions = {
    getBank({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        bankApi.dataBank(params).then(({ data: { data: { data } } }) => {
            if (data.length > 0) {
                commit('listBank', data);
            } else {
                commit('listBank', 'error');
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getListBank({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        bankApi.bankData().then(({ data: { data: { results } } }) => {
            commit('listDaftarBank', results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            commit('listDaftarBank', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    async add({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        await bankApi.addBank(value).then((res) => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response.data;
            commit('saveConfirmResponse', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    async update({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        await bankApi.updateBank(value).then((res) => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response.data;
            commit('saveConfirmResponse', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    async updateStatusBank({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        await bankApi.updateStatusBank({ 'member_bank_id': value }).then((res) => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response.data;
            commit('saveConfirmResponse', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    async hapus({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        await bankApi.deleteBank({ 'member_bank_id': value }).then(() => {
            dispatch("getBank");
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response.data;
            commit('saveConfirmResponse', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
}

const mutations = {
    listBank(state, data) {
        state.dataBank = data
    },
    listDaftarBank(state, data) {
        state.daftarBank = data
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = {}
        state.konfirmResponse = data
    },
    konfirmasiSukses(state, data) {
        state.responSukses = '';
        state.responSukses = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};